import PromoModal from './PromoModal.view';

export default PromoModal;
